export default __webpack_public_path__ + "static/media/lasallescreen.27cba8e9.png";